export enum ToastSeverity {
  SUCCESS = 'success',
  WARN = 'warn',
  INFO = 'info',
  ERROR = 'error'
}